import { ReactComponent as RateIcon } from './rate.svg';

export default RateIcon;
